import type { OrganizationThemeColors } from './types';
import { generateBrandScale, normalizeHexColor } from './color-scale';
import { DEFAULT_ORG_THEME_COLORS } from './defaults';

const BRAND_SCALE_STEPS = [
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
] as const;

/**
 * Injects account-level brand CSS variables on `:root`.
 * Survives user light/dark toggles — only hue ramps change per organization.
 */
export function applyOrganizationTheme(colors: OrganizationThemeColors): void {
  const primary = normalizeHexColor(colors.primary, DEFAULT_ORG_THEME_COLORS.primary);
  const accent = normalizeHexColor(colors.accent, DEFAULT_ORG_THEME_COLORS.accent);
  const scale = generateBrandScale(primary);
  const accentScale = generateBrandScale(accent);
  const root = document.documentElement;

  root.style.setProperty('--color-primary', primary);
  root.style.setProperty('--color-primary-hover', scale['600'] ?? primary);
  root.style.setProperty('--color-primary-muted', scale['100'] ?? primary);
  root.style.setProperty('--color-accent', accent);

  BRAND_SCALE_STEPS.forEach((step) => {
    root.style.setProperty(`--color-brand-${step}`, scale[step] ?? primary);
  });

  (['50', '100', '500', '600'] as const).forEach((step) => {
    root.style.setProperty(`--color-coral-${step}`, accentScale[step] ?? accent);
  });
}
